import Vue from "vue";
const view = Vue.extend({ render: h => h("router-view") });

// 预约实习期培训考核
const appointmentIndex = () =>
  import(
    /* webpackChunkName: "appointment-index" */ "@/views/teacher/training/appointment/index.vue"
  );
// 预约实习期培训考核结果
const appointmentResult = () =>
  import(
    /* webpackChunkName: "appointment-result" */ "@/views/teacher/training/appointment/result.vue"
  );
// 新兵营预览预览页面
const overview = () =>
  import(
    /* webpackChunkName: "training-overview" */ "@/views/teacher/training/overview/index.vue"
  );
// 岗后培训页面
const station = () =>
  import(
    /* webpackChunkName: "training-station" */ "@/views/teacher/training/station/index.vue"
  );
//岗后培训预约
const stationappointIndex = () =>
  import(
    /* webpackChunkName: "stationappoint-index" */ "@/views/teacher/training/stationappoint/index.vue"
  );
//岗后培训预约
const stationappointResult = () =>
  import(
    /* webpackChunkName: "stationappoint-result" */ "@/views/teacher/training/stationappoint/result.vue"
  );
// 课程规划-选择大分类
const planClass = () =>
  import(
    /* webpackChunkName: "training-plan-class" */ "@/views/teacher/training/plan/class.vue"
  );
// 课程规划选择课件-系列
const planSeries = () =>
  import(
    /* webpackChunkName: "training-plan-series" */ "@/views/teacher/training/plan/series.vue"
  );
// 课程规划选择课件-课程
const planCourse = () =>
  import(
    /* webpackChunkName: "training-plan-course" */ "@/views/teacher/training/plan/course.vue"
  );
// 课程规划-预览详情
const planDetail = () =>
  import(
    /* webpackChunkName: "training-plan-detail" */ "@/views/teacher/training/plan/detail.vue"
  );
// 实习完毕-确认阅读规章制度
const finishIndex = () =>
  import(
    /* webpackChunkName: "training-finish-index" */ "@/views/teacher/training/finish/index.vue"
  );
// 实习完毕-规章制度介绍
const finishIntro = () =>
  import(
    /* webpackChunkName: "training-finish-intro" */ "@/views/teacher/training/finish/intro.vue"
  );
// 实习完毕-确认固定时段
const trainingFixedTIme = () =>
  import(
    /* webpackChunkName: "training-fixed-time" */ "@/views/teacher/training/finish/fixedTime.vue"
  );
// 试听课与正式课上课流程 答题页
const trainingAnswer = () =>
  import(
    /* webpackChunkName: "training-answer-index" */ "@/views/teacher/training/answer/index.vue"
  );
// 试听课与正式课上课流程 目录页
const trainingAnswerExamine = () =>
  import(
    /* webpackChunkName: "training-answer-examine" */ "@/views/teacher/training/answer/examine.vue"
  );
export default {
  path: "training",
  component: view,
  children: [
    {
      path: "appointment",
      component: view,
      children: [
        {
          path: "index",
          name: "trainingAppointmentIndex",
          component: appointmentIndex
        },
        {
          path: "result",
          name: "trainingAppointmentResult",
          component: appointmentResult
        }
      ]
    },
    {
      name: "stationappoint",
      path: "stationappoint",
      component: view,
      children: [
        {
          name: "stationappointIndex",
          path: "index",
          component: stationappointIndex
        },
        {
          name: "stationappointResult",
          path: "result",
          component: stationappointResult
        }
      ]
    },
    {
      path: "overview",
      name: "overview",
      component: overview
    },
    {
      path: "plan",
      name: "plan",
      component: view,
      children: [
        {
          path: "class",
          name: "planClass",
          component: planClass,
          children: [
            {
              path: ":series_id",
              name: "planSeries",
              component: planSeries,
              children: [
                {
                  path: "/teacher/training/plan/class/:class_id/:series_id",
                  name: "planCourse",
                  component: planCourse
                }
              ]
            }
          ]
        },
        {
          path: "detail",
          name: "planDetail",
          component: planDetail
        }
      ]
    },
    {
      path: "station",
      name: "station",
      component: station
    },
    {
      path: "finish",
      component: view,
      children: [
        {
          path: "index",
          name: "trainingFinish",
          component: finishIndex
        },
        {
          path: "intro",
          name: "trainingIntro",
          component: finishIntro
        },
        {
          path: "fixedTIme",
          name: "trainingFixedTIme",
          component: trainingFixedTIme
        }
      ]
    },
    {
      path: "trainingAnswer",
      name: "trainingAnswer",
      component: trainingAnswer
    },
    {
      path: "trainingAnswerExamine",
      name: "trainingAnswerExamine",
      component: trainingAnswerExamine
    }
  ]
};
